<template>
    <div class="cT">
        <div class="content-bg">
            <div class="main" v-for="(item, index) in centerTopData" :key="index">
                <div class="m-item ">
                    <p class="title">{{ item.name }}</p>

                    <span class="num">{{ item.num1 }}</span>

                    <span class="unit">{{ item.unit }}</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'template.centerT-temp3',
    data() {
        return {
            centerTopData: [
                { name: "留守儿童", val: "mu", num1: '25', unit: "人" },
                { name: "空巢老人", val: "mu", num1: '20', unit: "人" },
                { name: "贫苦户", val: "mu", num1: '8', unit: "人" },
                { name: "残疾人员", val: "mu", num1: '5', unit: "人" },
                { name: "退役人员", val: "mu", num1: '12', unit: "人" },
                { name: "党员人数", val: "ha", num1: '35', unit: "人" },
            ]
        }
    },
    mounted() {

    },
    watch: {
    },
    methods: {

    },
    beforeDestroy() {

    },
}
</script>

<style scoped lang="scss">
@font-face {
    font-family: "YouSheBiaoTiHei";
    src: url("../../assets/fonts/YouSheBiaoTiHei.woff2");
}


.cT {
    width: 870px;
    height: 80px;
    display: flex;
    justify-content: space-between;
    margin: 0px auto;
    z-index: 999;
    position: relative;
}

.content-bg {
    width: 870px;
    height: 80px;
    background: url('../../assets/template3/cent-top.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    z-index: 1;
    padding: 0 34px;

    .main {
        width: 100px;
        display: flex;
        text-align: center;
        margin: 16px auto;

    }

    .m-item {

        // padding: 12px 0 0 10px;
        .title {
            width: 85px;
            height: 14px;
            font-family: Source Han Sans CN;
            // font-weight: 400;
            font-size: 14px;
            color: #e3e4e6;
            margin-bottom: 6px;
            position: relative;

        }

        .title::after {
            content: "";
            width: 6px;
            height: 6px;
            background: #fec705;
            position: absolute;
            left: 0px;
            top: 50%;

        }

        .num {

            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 26px;
            font-family: "YouSheBiaoTiHei";
            color: #00ccdc;
            margin: 0 6px 0 0;

        }

        .unit {
            width: 24px;
            height: 11px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #CBCBCB;
        }
    }
}
</style>